import React from 'react';
import { Coins, ArrowRight } from 'lucide-react';

/**
 * TokenConsultationBanner — the unified $5 = 1 consultation callout.
 * Mandate: unmissable but elegant.  Home + consultation surfaces.
 */
export default function TokenConsultationBanner({ variant = 'default' }) {
  const isCompact = variant === 'compact';

  return (
    <section
      data-testid="token-consultation-banner"
      aria-label="Token consultation pricing"
      className={
        isCompact
          ? 'w-full flex justify-center py-4'
          : 'w-full flex justify-center py-8 px-4'
      }
    >
      <div
        className={
          'relative overflow-hidden rounded-2xl border-2 border-amber-400/50 bg-gradient-to-r from-amber-950/60 via-purple-950/60 to-amber-950/60 shadow-xl shadow-amber-500/10 backdrop-blur ' +
          (isCompact ? 'px-5 py-3 max-w-xl' : 'px-6 md:px-10 py-6 max-w-3xl')
        }
      >
        {/* subtle grid pattern */}
        <div
          aria-hidden="true"
          className="absolute inset-0 opacity-[0.06] pointer-events-none"
          style={{
            backgroundImage:
              'radial-gradient(circle at 1px 1px, #fbbf24 1px, transparent 0)',
            backgroundSize: '20px 20px',
          }}
        />
        <div className="relative flex flex-col md:flex-row items-center gap-4 md:gap-6">
          <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber-400/20 border border-amber-300/60 flex-shrink-0">
            <Coins className="w-6 h-6 text-amber-300" />
          </span>
          <div className="text-center md:text-left flex-1">
            <p
              className="text-[10px] font-mono uppercase tracking-[0.32em] text-amber-300/80 mb-1"
              data-testid="token-banner-eyebrow"
            >
              Unified NextXus Token · Bearer Instrument
            </p>
            <p
              className="text-xl md:text-2xl font-extrabold text-white leading-tight"
              data-testid="token-banner-message"
            >
              One token{' '}
              <span className="text-amber-300">($5)</span>
              {' = '}
              <span className="text-amber-300">one consultation.</span>
            </p>
            {!isCompact && (
              <p className="text-xs md:text-sm text-amber-100/75 mt-2">
                Redeemable anywhere in the Federation · portable across all 5
                pillars · no subscription required.
              </p>
            )}
          </div>
          <a
            href="#catalog"
            data-testid="token-banner-cta"
            className="inline-flex items-center gap-2 rounded-full bg-amber-400 hover:bg-amber-300 text-black font-bold px-5 py-3 text-sm shadow-lg shadow-amber-500/30 transition-colors"
          >
            Redeem a Token <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
